import React from 'react';
import Navbar from './home/Navbar';
import Footer from './home/Footer';
import HomePage from './home/HomePage';

const MainLayout = ({ children }) => {
    return (
        <div className='bg-gradient-to-r from-white to-gray-300/80 text-gray-900 min-h-screen'>
            
            {/* <div>{children}</div> */}
            
            <HomePage/>
            <Footer/>
            
        </div>
    );
};

export default MainLayout;
